import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/plaster.svg` */
export const PlasterSolidIcon = createTripletGlyphIcon('PlasterSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3643 9.48499C14.4388 10.57 14.4298 12.3207 13.3448 13.3951C12.26 14.4693 10.5101 14.461 9.43564 13.3766L8.37509 12.3063L12.3038 8.41468L13.3643 9.48499Z"
        fill="currentColor"
      />
      <path
        d="M7.39755 9.39026C7.67368 9.39026 7.89753 9.61414 7.89755 9.89026C7.89755 10.1664 7.67369 10.3903 7.39755 10.3903C7.12157 10.3901 6.89755 10.1663 6.89755 9.89026C6.89757 9.61425 7.12158 9.39045 7.39755 9.39026Z"
        fill="currentColor"
      />
      <path
        d="M6.12216 8.11292C6.39815 8.11308 6.62214 8.33689 6.62216 8.61292C6.62216 8.88896 6.39816 9.11276 6.12216 9.11292C5.84602 9.11292 5.62216 8.88906 5.62216 8.61292C5.62218 8.33679 5.84603 8.11292 6.12216 8.11292Z"
        fill="currentColor"
      />
      <path
        d="M8.67685 8.11292C8.95284 8.11308 9.17683 8.33689 9.17685 8.61292C9.17685 8.88896 8.95285 9.11276 8.67685 9.11292C8.4007 9.11292 8.17685 8.88906 8.17685 8.61292C8.17686 8.33679 8.40072 8.11292 8.67685 8.11292Z"
        fill="currentColor"
      />
      <path
        d="M9.95517 6.96253C10.2313 6.96253 10.4551 7.1864 10.4552 7.46253C10.4552 7.73867 10.2313 7.96253 9.95517 7.96253C9.67904 7.96252 9.45517 7.73866 9.45517 7.46253C9.45518 7.18641 9.67905 6.96254 9.95517 6.96253Z"
        fill="currentColor"
      />
      <path
        d="M7.39755 6.83558C7.67368 6.83558 7.89753 7.05945 7.89755 7.33558C7.89755 7.61172 7.67369 7.83558 7.39755 7.83558C7.12157 7.83539 6.89755 7.6116 6.89755 7.33558C6.89757 7.05957 7.12158 6.83577 7.39755 6.83558Z"
        fill="currentColor"
      />
      <path
        d="M8.67685 5.68519C8.95283 5.68535 9.17681 5.90917 9.17685 6.18519C9.17685 6.46123 8.95285 6.68502 8.67685 6.68519C8.4007 6.68519 8.17685 6.46133 8.17685 6.18519C8.17688 5.90907 8.40072 5.68519 8.67685 5.68519Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.64853 2.43519C10.731 1.54539 12.3326 1.60177 13.3487 2.60999L13.5392 2.81995C14.3695 3.83041 14.3757 5.2936 13.5528 6.31019L13.3634 6.52015L6.56064 13.3746C5.48507 14.458 3.73518 14.4645 2.65146 13.3893C1.56784 12.3137 1.56042 10.5629 2.63583 9.47913L9.43856 2.62464L9.64853 2.43519ZM12.5733 3.39124C11.9209 2.74398 10.8675 2.74712 10.2198 3.39905L3.41708 10.2535C2.76956 10.9061 2.77343 11.9614 3.42587 12.609C4.0784 13.2563 5.13275 13.2524 5.78036 12.6002L12.5831 5.74573C13.2306 5.09311 13.2259 4.03886 12.5733 3.39124Z"
        fill="currentColor"
      />
      <path
        d="M2.65927 2.60511C3.74423 1.53064 5.49495 1.5387 6.56942 2.62366L7.62899 3.69398L3.70028 7.5846L2.63974 6.51429C1.56568 5.42934 1.57456 3.67947 2.65927 2.60511Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2177 9.84611L15.0351 10.6703C16.2439 11.8909 16.2342 13.861 15.0136 15.0697C13.7931 16.2783 11.8239 16.2684 10.6152 15.0483L9.4218 13.8442L13.8427 9.46623L14.2177 9.84611Z"
        fill="currentColor"
      />
      <path
        d="M8.32219 10.5639C8.63284 10.5639 8.88468 10.8157 8.88469 11.1264C8.88469 11.437 8.63285 11.6889 8.32219 11.6889C8.01176 11.6886 7.76067 11.4369 7.76067 11.1264C7.76069 10.8159 8.01177 10.5641 8.32219 10.5639Z"
        fill="currentColor"
      />
      <path
        d="M6.88762 9.12736C7.19806 9.12762 7.45012 9.37936 7.45012 9.68986C7.44988 10.0001 7.19791 10.2521 6.88762 10.2524C6.57712 10.2524 6.32537 10.0003 6.32512 9.68986C6.32512 9.3792 6.57697 9.12736 6.88762 9.12736Z"
        fill="currentColor"
      />
      <path
        d="M9.76067 9.12736C10.0713 9.12736 10.3232 9.3792 10.3232 9.68986C10.3229 10.0003 10.0712 10.2524 9.76067 10.2524C9.45038 10.2521 9.19842 10.0001 9.19817 9.68986C9.19817 9.37936 9.45023 9.12762 9.76067 9.12736Z"
        fill="currentColor"
      />
      <path
        d="M11.1991 7.83244C11.5097 7.83244 11.7615 8.08441 11.7616 8.39494C11.7616 8.7056 11.5098 8.95744 11.1991 8.95744C10.8887 8.95718 10.6366 8.70544 10.6366 8.39494C10.6368 8.08457 10.8888 7.83269 11.1991 7.83244Z"
        fill="currentColor"
      />
      <path
        d="M8.32219 7.68986C8.63284 7.68986 8.88467 7.94172 8.88469 8.25236C8.88469 8.56302 8.63285 8.81486 8.32219 8.81486C8.01176 8.8146 7.76067 8.56285 7.76067 8.25236C7.76069 7.94188 8.01177 7.69012 8.32219 7.68986Z"
        fill="currentColor"
      />
      <path
        d="M9.76067 6.39591C10.0713 6.39591 10.3232 6.64776 10.3232 6.95841C10.3231 7.26898 10.0713 7.52091 9.76067 7.52091C9.4503 7.52065 9.19828 7.26882 9.19817 6.95841C9.19817 6.64792 9.45023 6.39617 9.76067 6.39591Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7343 2.8422C11.951 1.73477 13.8364 1.76405 15.0175 2.93595L15.1288 3.05216C16.2005 4.22957 16.207 6.03262 15.1445 7.21818L15.0341 7.33537L7.38079 15.0463C6.17066 16.2652 4.2015 16.2729 2.98235 15.0629C1.76327 13.8529 1.75605 11.8838 2.96575 10.6645L10.6191 2.95255L10.7343 2.8422ZM14.2421 3.7172C13.4541 2.93548 12.1814 2.93937 11.3993 3.72697L3.74602 11.4389C2.96428 12.227 2.96887 13.5006 3.75676 14.2826C4.54472 15.0647 5.81834 15.0596 6.60051 14.2719L14.2538 6.55998C15.0356 5.77186 15.0301 4.49922 14.2421 3.7172Z"
        fill="currentColor"
      />
      <path
        d="M2.99114 2.93009C4.21173 1.72131 6.18177 1.73099 7.39055 2.95158L8.58294 4.15568L4.16301 8.53263L3.78704 8.15373L2.97063 7.32853C1.76193 6.10802 1.77079 4.1389 2.99114 2.93009Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0461 14.2283C21.6579 15.8558 21.6453 18.4818 20.0178 20.0936C18.3903 21.705 15.7642 21.6916 14.1526 20.0643L12.5627 18.4588L18.4563 12.6229L20.0461 14.2283Z"
        fill="currentColor"
      />
      <path
        d="M11.0969 14.0857C11.5111 14.0857 11.8469 14.4216 11.8469 14.8357C11.8469 15.25 11.5111 15.5857 11.0969 15.5857C10.6827 15.5857 10.3469 15.2499 10.3469 14.8357C10.347 14.4216 10.6828 14.0858 11.0969 14.0857Z"
        fill="currentColor"
      />
      <path
        d="M9.18286 12.1697C9.59704 12.1697 9.93281 12.5056 9.93286 12.9197C9.93286 13.3339 9.59707 13.6697 9.18286 13.6697C8.76868 13.6697 8.43286 13.3339 8.43286 12.9197C8.4329 12.5056 8.76871 12.1698 9.18286 12.1697Z"
        fill="currentColor"
      />
      <path
        d="M13.0149 12.1697C13.4291 12.1697 13.7648 12.5056 13.7649 12.9197C13.7649 13.3339 13.4291 13.6697 13.0149 13.6697C12.6007 13.6697 12.2649 13.3339 12.2649 12.9197C12.2649 12.5056 12.6007 12.1698 13.0149 12.1697Z"
        fill="currentColor"
      />
      <path
        d="M14.9329 10.4441C15.347 10.4441 15.6828 10.78 15.6829 11.1941C15.6829 11.6084 15.3471 11.9441 14.9329 11.9441C14.5187 11.9441 14.1829 11.6083 14.1829 11.1941C14.1829 10.78 14.5187 10.4442 14.9329 10.4441Z"
        fill="currentColor"
      />
      <path
        d="M11.0969 10.2537C11.5111 10.2537 11.8469 10.5895 11.8469 11.0037C11.8469 11.4179 11.5111 11.7537 11.0969 11.7537C10.6827 11.7537 10.3469 11.4179 10.3469 11.0037C10.347 10.5896 10.6828 10.2538 11.0969 10.2537Z"
        fill="currentColor"
      />
      <path
        d="M13.0149 8.52813C13.4291 8.52813 13.7648 8.86396 13.7649 9.27813C13.7649 9.69234 13.4291 10.0281 13.0149 10.0281C12.6007 10.0281 12.2649 9.69232 12.2649 9.27813C12.2649 8.86399 12.6007 8.52818 13.0149 8.52813Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3127 3.79083C15.9352 2.31365 18.4487 2.35277 20.0237 3.91583L20.1711 4.07012C21.6005 5.64027 21.6093 8.04494 20.1916 9.62579L20.0461 9.78106L9.84204 20.0623L9.68774 20.2098C8.11755 21.6391 5.71288 21.6479 4.13207 20.2303L3.9768 20.0848C2.40197 18.5218 2.34334 16.0084 3.80786 14.3748L3.95434 14.2195L14.1584 3.93731L14.3127 3.79083ZM19.1077 4.83868C17.9916 3.73117 16.189 3.73756 15.0813 4.85333L4.87719 15.1346C3.76948 16.2507 3.7767 18.0542 4.89282 19.1619C6.00894 20.2693 7.81156 20.2623 8.91918 19.1463L19.1233 8.86504C20.2307 7.74895 20.2236 5.94632 19.1077 4.83868Z"
        fill="currentColor"
      />
      <path
        d="M3.98852 3.90704C5.6159 2.29544 8.24203 2.30817 9.85375 3.93536L10.9426 5.03594L11.4436 5.54083L5.55004 11.3777L3.9602 9.77227C2.34856 8.14481 2.36109 5.51873 3.98852 3.90704Z"
        fill="currentColor"
      />
    </svg>
  ),
});
